// extracted by mini-css-extract-plugin
export var wrap = "pageheader-module--wrap--3yZ1s";
export var breadcrumbs = "pageheader-module--breadcrumbs--2pNa1";
export var titleArea = "pageheader-module--titleArea--3tI3G";
export var underline = "pageheader-module--underline--2j6PP";